import React from 'react'
import ModalDrawer from '../../../common/components/organisme/ModalDrawer/ModalDrawer';
import useQueryURL from '../../../common/hooks/useQueryURL';
import AddNewConnectorFormPresenter from '../../../features/stations/components/NewConnector/AddNewConnectorForm/AddNewConnectorFormPresenter';

export const EDIT_CONNECTOR_MODAL_ID = "edit-connector-modal";

export default function EditConnectorPage() {

  const { getQueryValue, removeQueryValue } = useQueryURL();
  const connectorId = getQueryValue("connectorId");
  const chargePointId = getQueryValue("chargePointId");

  const onSuccess = (data: any) => {
    removeQueryValue([EDIT_CONNECTOR_MODAL_ID]);

  }

  return (

      <AddNewConnectorFormPresenter isUpdate connectorIdToUpdate={connectorId || undefined} chargePointId={chargePointId || undefined} onSuccess={onSuccess}/>

  )
}

export const EditConnectorPageDrawer = ({modalId, zIndex}: {modalId?: string, zIndex?: number}) => {
    const modalIdFound = modalId || EDIT_CONNECTOR_MODAL_ID;



    const onClose = () => {
       // removeQueryValue(["connectorId", modalIdFound]);
    }

    return (
        <ModalDrawer
        urlParamName={modalIdFound}
     
        onClose={onClose}
        zIndex={zIndex}
        >
            <EditConnectorPage />
        </ModalDrawer>
    )
}